import createReactClass from  'create-react-class';

window.createReactClass=createReactClass;
//内部信息
export {default as ComponentMap} from './ComponentMap';
export {default as Main} from './Main';



// WEBPACK FOOTER //
// ./component/index.js